import DataTable from "../dataTables";

/**
 * Thin adapter to keep server-side pagination/sort/filter policy out of callers.
 */
export default function ServerDataTableAdapter(props) {
  return <DataTable {...props} serverSidePagination />;
}
